// src/components/kempower/ChargingSocketsCard.js
import React from 'react';
import StatusPill from '../../../shared/components/pill/StatusPill';

export default function ChargingSocketsCard({ connectors }) {
  // e.g. connectors = [ { name, type, powerKw, status }, ... ]
  if (!connectors || connectors.length === 0) return null;

  return (
    <div className="card mb-3">
      <div className="card-body">
        <h6 className="card-title mb-3 fw-bold">Charging Sockets</h6>
        {connectors.map((conn, i) => {
          // e.g. show an icon
          const statusTone = (conn.status?.toLowerCase() === 'available')
            ? 'success'
            : (conn.status?.toLowerCase() === 'charging')
              ? 'progress'
              : 'neutral';

          return (
            <div key={i} className="d-flex justify-content-between align-items-center mb-2 p-2" style={{ backgroundColor: '#f8f9fa', borderRadius: '6px' }}>
              <div>
                <i className="bi bi-plug me-2 text-primary"></i>
                <strong>{conn.name || `Socket ${i + 1}`}</strong>
                <div className="small text-muted">{conn.powerKw}kW {conn.type || ''}</div>
              </div>
              <StatusPill tone={statusTone} size="touch">
                {conn.status || 'Unknown'}
              </StatusPill>
            </div>
          );
        })}
      </div>
    </div>
  );
}
